import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let AmStep = class AmStep extends Vue {
  handleHTMLChange() {
    const html = this.$refs.refHTML;
    if (html) {
      try {
        html.scrollTop = 0;
        html.scrollTo(0, 0);
      } catch (err) {}
    } else {
      console.log('找不到html');
    }
  }
  get lineStyle() {
    if (this.autoHeight) {
      return `height: auto;width:${this.width};`;
    }
    return `height: ${this.height};width:${this.width};`;
  }
};
AmStep.componentName = 'AmHtml';
__decorate([Prop({
  default: ''
})], AmStep.prototype, "html", void 0);
__decorate([Watch('html')], AmStep.prototype, "handleHTMLChange", null);
__decorate([Prop({
  default: '100%'
})], AmStep.prototype, "width", void 0);
__decorate([Prop({
  default: '100%'
})], AmStep.prototype, "height", void 0);
__decorate([Prop({
  default: false
})], AmStep.prototype, "autoHeight", void 0);
__decorate([Prop({
  default: 'no'
})], AmStep.prototype, "scrolling", void 0);
AmStep = __decorate([Component({
  name: 'AmHtml'
})], AmStep);
export default AmStep;